/**
 * Sincroniza el grid del facturador con el catálogo del servidor
 * (productos nuevos, precios y nombres) sin recargar la app.
 */

let syncing = false;
let queued = false;

function esc(s) {
	return String(s == null ? '' : s)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function placeholderImg() {
	const img = document.querySelector('.producto-card img');
	if (img && img.getAttribute('src')) return img.getAttribute('src');
	return 'data:image/svg+xml,' + encodeURIComponent(
		'<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><rect fill="#eef2f6" width="80" height="80"/></svg>',
	);
}

function findProducto(id) {
	const pid = parseInt(id, 10);
	const data = window.productosData || [];
	for (let i = 0; i < data.length; i++) {
		const products = data[i] && data[i].products;
		if (!Array.isArray(products)) continue;
		for (let j = 0; j < products.length; j++) {
			if (products[j] && parseInt(products[j].id, 10) === pid) return products[j];
		}
	}
	return null;
}

function cknDesdeUsd(product) {
	if (!product || !product.is_composite || !product.composite_data || !Array.isArray(product.composite_data.groups)) {
		return 0;
	}
	let extra = 0;
	product.composite_data.groups.forEach((group) => {
		if (!group || group.optional) return;
		const min = parseInt(group.min != null ? group.min : 1, 10);
		if (min <= 0) return;
		const prices = (group.options || []).map((opt) => {
			if (!opt) return 0;
			if (opt.lines || opt.recipe_id || opt.type === 'recipe' || Object.prototype.hasOwnProperty.call(opt, 'price_extra')) {
				return parseFloat(opt.price_extra || 0) || 0;
			}
			return parseFloat(opt.price || 0) || 0;
		});
		if (!prices.length) return;
		prices.sort((a, b) => a - b);
		extra += prices[0];
	});
	return extra;
}

function bindCard(card, productId) {
	card.onclick = function onProductoCardClick(ev) {
		if (ev) ev.preventDefault();
		const p = findProducto(productId);
		if (p && typeof window.abrirModalProducto === 'function') {
			window.abrirModalProducto(p);
		}
	};
	card.removeAttribute('onclick');
}

function panelRoot() {
	return document.querySelector('.productos-panel');
}

function ensureCategory(slug, name) {
	const sel = document.getElementById('category-select');
	if (sel) {
		let has = false;
		for (let i = 0; i < sel.options.length; i++) {
			if (sel.options[i].value === slug) {
				has = true;
				break;
			}
		}
		if (!has) {
			const opt = document.createElement('option');
			opt.value = slug;
			opt.textContent = '📂 ' + name;
			sel.appendChild(opt);
		}
	}

	let container = document.querySelector(`.productos-container[data-category="${slug}"]`);
	if (container) return container;

	const panel = panelRoot();
	if (!panel) return null;

	const empty = Array.from(panel.querySelectorAll('div')).find(
		(el) => el.childElementCount === 0 && /No hay productos/i.test(el.textContent || ''),
	);
	if (empty) empty.remove();

	if (!document.getElementById('category-select')) {
		const drop = document.createElement('div');
		drop.className = 'category-dropdown';
		drop.innerHTML = `<select id="category-select"><option value="${esc(slug)}" selected>📂 ${esc(name)}</option></select>`;
		const header = panel.querySelector('.productos-header');
		if (header && header.nextSibling) {
			panel.insertBefore(drop, header.nextSibling);
		} else {
			panel.appendChild(drop);
		}
	}

	container = document.createElement('div');
	container.className = 'productos-container';
	container.setAttribute('data-category', slug);
	container.innerHTML =
		'<div class="productos-grid"></div>' +
		`<div class="productos-pagination" data-category="${esc(slug)}" style="display:none;margin:6px 0;">` +
		'<button type="button" class="pagination-prev">◀ Anterior</button>' +
		'<span class="page-info">Página 1 de 1</span>' +
		'<button type="button" class="pagination-next">Siguiente ▶</button></div>';

	const listos = document.getElementById('poskn-pedidos-listos-box');
	if (listos && listos.parentNode === panel) {
		panel.insertBefore(container, listos);
	} else {
		panel.appendChild(container);
	}

	if (!document.querySelector('.productos-container.active')) {
		container.classList.add('active');
		container.style.display = '';
	} else {
		container.style.display = 'none';
	}

	return container;
}

function upsertCard(grid, product) {
	const pid = parseInt(product.id, 10);
	if (!pid || !grid) return;
	let card = grid.querySelector(`.producto-card[data-product-id="${pid}"]`);
	const name = product.name || '';
	const sku = product.sku || '';
	const extra = cknDesdeUsd(product);
	const usd = (parseFloat(product.price_usd != null ? product.price_usd : product.price) || 0) + extra;
	const bs = (parseFloat(product.price_bs != null ? product.price_bs : usd * (window.TASA_DOLAR || 1)) || 0) + extra * (window.TASA_DOLAR || 1);
	const pref = extra > 0.0001 ? 'Desde ' : '';
	const img = product.image || placeholderImg();
	const managing = product.managing_stock ? '1' : '0';
	const stock = product.stock != null && product.stock !== '' ? product.stock : '';
	const type = product.type || 'simple';

	if (!card) {
		card = document.createElement('div');
		card.className = 'producto-card';
		card.setAttribute('data-product-id', String(pid));
		card.innerHTML =
			`<div class="producto-image"><img alt="" loading="lazy"></div>` +
			`<div class="producto-name"></div>` +
			`<div class="producto-sku"></div>` +
			`<div class="producto-precios" style="display:flex;flex-direction:column;gap:2px;margin-top:6px;margin-bottom:6px;visibility:visible;opacity:1;">` +
			`<span class="producto-price-usd" style="display:block;font-size:18px;color:#2196F3;font-weight:bold;visibility:visible;"></span>` +
			(window.POSKN_MULTIMONEDA
				? `<span class="producto-price-bs" style="display:block;font-size:16px;color:#4CAF50;font-weight:600;visibility:visible;"></span>`
				: '') +
			`</div>` +
			`<div class="producto-stock" data-stock-label></div>`;
		grid.appendChild(card);
	}

	card.setAttribute('data-product-type', type);
	card.setAttribute('data-managing-stock', managing);
	card.setAttribute('data-stock-global', stock === null || stock === undefined ? '' : String(stock));
	card.setAttribute('data-product-name', String(name).toLowerCase());
	card.setAttribute('data-product-sku', String(sku).toLowerCase());
	card.setAttribute('data-price-anchor', product.price_anchor || 'usd');
	card.setAttribute('data-price-bs-fixed', String(product.price_bs_fixed || 0));
	card.setAttribute('data-price-wc-usd', String(product.price_wc_usd != null ? product.price_wc_usd : product.price || 0));
	card.setAttribute('data-ckn-desde-usd', String(extra));

	const imgEl = card.querySelector('.producto-image img');
	if (imgEl) {
		imgEl.src = img;
		imgEl.alt = name;
	}
	const nameEl = card.querySelector('.producto-name');
	if (nameEl) nameEl.textContent = name;
	const skuEl = card.querySelector('.producto-sku');
	if (skuEl) {
		if (sku) {
			skuEl.textContent = 'SKU: ' + sku;
			skuEl.style.display = '';
		} else {
			skuEl.textContent = '';
			skuEl.style.display = 'none';
		}
	}
	const usdEl = card.querySelector('.producto-price-usd');
	if (usdEl) usdEl.textContent = `${pref}$${usd.toFixed(2)}`;
	const bsEl = card.querySelector('.producto-price-bs');
	if (bsEl) bsEl.textContent = `${pref}Bs. ${bs.toFixed(2)}`;

	bindCard(card, pid);
}

function applyCatalog(catalog) {
	if (!Array.isArray(catalog)) return { added: 0 };

	window.productosData = catalog;
	if (typeof window.posknOverlayProductosDataDesdeTienda === 'function') {
		window.posknOverlayProductosDataDesdeTienda();
	}

	const keep = {};
	let added = 0;
	catalog.forEach((cat) => {
		if (!cat || !cat.category_slug) return;
		const container = ensureCategory(cat.category_slug, cat.category_name || cat.category_slug);
		if (!container) return;
		const grid = container.querySelector('.productos-grid');
		if (!grid) return;
		(cat.products || []).forEach((product) => {
			const pid = parseInt(product && product.id, 10);
			if (!pid) return;
			const existed = !!grid.querySelector(`.producto-card[data-product-id="${pid}"]`);
			upsertCard(grid, product);
			keep[`${cat.category_slug}:${pid}`] = true;
			if (!existed) added += 1;
		});
	});

	document.querySelectorAll('.productos-container').forEach((container) => {
		const slug = container.getAttribute('data-category') || '';
		container.querySelectorAll('.producto-card').forEach((card) => {
			const pid = card.getAttribute('data-product-id') || '';
			if (!keep[`${slug}:${pid}`]) {
				card.remove();
			}
		});
	});

	document.querySelectorAll('.producto-card').forEach((card) => {
		const pid = parseInt(card.getAttribute('data-product-id') || '0', 10);
		if (pid) bindCard(card, pid);
	});

	const active = document.querySelector('.productos-container.active');
	const cat = (active && active.getAttribute('data-category')) || (document.getElementById('category-select') || {}).value;
	if (cat && typeof window.posknInitPagination === 'function') {
		window.posknInitPagination(cat);
	}
	if (typeof window.posknActualizarStockVisualProductos === 'function') {
		window.posknActualizarStockVisualProductos();
	}
	if (typeof window.posknActualizarPreciosEnPantalla === 'function') {
		window.posknActualizarPreciosEnPantalla();
	}
	if (typeof window.posknSaveOfflineSnapshot === 'function') {
		window.posknSaveOfflineSnapshot();
	}

	return { added };
}

export function initCatalogSync(win) {
	if (win._posknCatalogSyncBound) return;
	win._posknCatalogSyncBound = true;

	win.posknApplyPosCatalog = applyCatalog;

	win.posknSyncCatalogFromServer = function posknSyncCatalogFromServer() {
		if (syncing) {
			queued = true;
			return;
		}
		if (!win.POSKN || !win.POSKN.api || typeof win.POSKN.api.getProductsCatalog !== 'function') {
			return;
		}
		syncing = true;
		const req = win.POSKN.api.getProductsCatalog(60000);
		const done = (res) => {
			syncing = false;
			const catalog = res && res.success && res.data && (res.data.catalog || res.data.pos_data);
			if (Array.isArray(catalog)) {
				const result = applyCatalog(catalog);
				if (result.added > 0 && typeof win.mostrarNotificacion === 'function') {
					win.mostrarNotificacion(
						result.added === 1 ? 'Producto nuevo en el facturador' : `${result.added} productos nuevos en el facturador`,
						'success',
					);
				}
				if (typeof win.posknRefrescarStockEnVivo === 'function') {
					win.posknRefrescarStockEnVivo({ force: true, full: true });
				}
			}
			if (queued) {
				queued = false;
				win.posknSyncCatalogFromServer();
			}
		};
		if (req && typeof req.done === 'function') {
			req.done(done).fail(() => {
				syncing = false;
			});
		} else if (req && typeof req.then === 'function') {
			req.then(done).catch(() => {
				syncing = false;
			});
		} else {
			syncing = false;
		}
	};
}
